module.exports = __webpack_public_path__ + "img/rsz_8b.559b3796.png";